module.exports = __webpack_public_path__ + "static/media/sf_1600.7a254d30b7558ce01d106dd4a627529c.png";